import { Center, Flex, Spinner, useBoolean } from '@chakra-ui/react';
import { IconSearchData } from 'hooks/usePaginatedIconSearch';
import { useUser } from 'modules/User';
import { ReactElement } from 'react';

import { IconPreview } from './IconPreview';

type onClickIconWidget = (id: string, viewBox: string, mono?: boolean, iconMetadata?: { iconPath: string }) => void;

interface IconListProps {
  icons: IconSearchData[];
  onClickIconWidget: onClickIconWidget;
  testId?: string;
}

export const IconList = ({
  icons,
  onClickIconWidget,
  testId = 'iconwidgetmenu-icon-list',
}: IconListProps): ReactElement => {
  const [isLoading, setIsLoading] = useBoolean(true);
  const { userType } = useUser();

  const onLoadIcon = () => {
    if (isLoading) {
      setIsLoading.off();
    }
  };

  const handleClickIconWidget = (id: string, viewBox: string, icon: IconSearchData) => {
    onClickIconWidget(id, viewBox, icon.isMono, icon.iconPath ? { iconPath: icon.iconPath } : undefined);
  };

  return (
    <>
      <Flex wrap='wrap' gap='8px' data-testid={testId} p={1} pr={0}>
        {icons.map((icon: IconSearchData) => {
          return (
            <IconPreview
              id={icon.id}
              key={icon.id}
              userType={userType}
              permission={icon.permission}
              onClickIconWidget={(id: string, viewBox: string) => handleClickIconWidget(id, viewBox, icon)}
              onLoad={onLoadIcon}
              iconPath={icon.iconPath}
              isMono={icon.isMono}
            />
          );
        })}
      </Flex>

      {isLoading && (
        <Center>
          <Spinner data-testid='icon-widgetmenu-list-spinner' alignSelf='center' color='var(--vg-colors-brand-500)' />
        </Center>
      )}
    </>
  );
};
